/* globals LUX: false */
import get from 'lodash/get'
import $ from 'jquery'
import Event from 'base/event'

import Hub from 'base/hub'
import 'base/lib/transition-timer'
import addScript from 'base/lib/addScript'
import store from 'base/store'
import { warn } from 'base/lib/console'

const VARIABLES = {
  checkoutAddToCart: 'atc',
  checkoutComplete: 'co',
  checkoutTotal: 't',
  device: 'd',
  gender: 'g',
  userID: 'uid',
}

function shouldInitialize() {
  if (!store.getState().appConfig.isProductionLike) {
    return false
  }

  if (window.LUX == null) {
    warn('window.LUX not found; cannot configure')
    return false
  }

  return true
}

function initializeClient() {
  addScript('https://cdn.speedcurve.com/js/lux.js?id=346023559', {
    async: true,
    crossorigin: 'anonymous',
    defer: true,
  })
}

function device() {
  return store.getState().appConfig.isMobile ? 'mobile' : 'desktop'
}

function initializeData() {
  LUX.addData(VARIABLES.checkoutTotal, 0)
  LUX.addData(VARIABLES.userID, get(store.getState(), 'session.user.guid', '-'))
  LUX.addData(VARIABLES.device, device())
  LUX.addData(VARIABLES.gender, get(store.getState(), 'session.user.gender', '-'))
}

function initializeListeners() {
  Hub.sub(Event.Checkout.ADD_TO_CART, () => LUX.addData(VARIABLES.checkoutAddToCart, '1'))

  Hub.sub(Event.Checkout.COMPLETE, (event, order) => {
    LUX.addData(VARIABLES.checkoutComplete, '1')
    LUX.addData(VARIABLES.checkoutTotal, order.gross_total)
  })
}

function blockTransitionsOnAJAX() {
  $(document).on('ajaxSend', (event, response, req) => {
    Hub.pub(Event.App.TRANSITION_HOLD, req.url)
  })

  $(document).on('ajaxComplete', (event, response, req) => {
    Hub.pub(Event.App.TRANSITION_ADVANCE, req.url)
  })
}

function captureSPATiming() {
  const TRANSITION_TIMEOUT = 10000
  let transitionTimeout = null
  let isFirstTransition = true

  Hub.sub(Event.App.TRANSITION_START, (eventName, routeName) => {
    // TODO: move the timeout logic to transition-timer.js. We'll want a way to
    // silence the console.time and console.warn in test mode.
    clearTimeout(transitionTimeout)
    console.time('transition')

    transitionTimeout = setTimeout(() => {
      console.warn(
        `${routeName} did not mark its transition complete in under ${TRANSITION_TIMEOUT}ms. This may indicate a code error or simply a slow-loading route.`,
      )
    }, TRANSITION_TIMEOUT)

    if (window.LUX != null) {
      LUX.label = routeName

      if (!isFirstTransition) {
        LUX.init()
      }
    }

    isFirstTransition = false
  })

  Hub.sub(Event.App.TRANSITION_END, () => {
    clearTimeout(transitionTimeout)
    console.timeEnd('transition')

    if (window.LUX != null) {
      LUX.send()
    }
  })
}

export default function initializeSpeedCurve() {
  blockTransitionsOnAJAX()
  captureSPATiming()

  if (shouldInitialize()) {
    initializeClient()
    initializeData()
    initializeListeners()
  }
}
